import { useEffect, useRef, useState } from "react";
import { Volume2, VolumeX } from "lucide-react";

export default function SalesVideo() {
  const ref = useRef(null);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          v.play().catch(() => {});
        } else {
          v.pause();
        }
      },
      { threshold: 0.25 }
    );
    obs.observe(v);
    return () => obs.disconnect();
  }, []);

  const toggle = () => {
    const v = ref.current;
    if (!v) return;
    v.muted = !v.muted;
    if (v.muted === false) v.currentTime = 0;
    setMuted(v.muted);
    v.play();
  };

  return (
    <div className="relative card-brutal" data-testid="sales-video-card">
      <video
        ref={ref}
        poster="/hotwater-pitch-poster.webp"
        muted
        loop
        playsInline
        preload="none"
        className="w-full h-full object-cover aspect-video"
        data-testid="sales-video"
      >
        <source src="/hotwater-pitch.webm" type="video/webm" />
        <source src="/hotwater-pitch.mp4" type="video/mp4" />
      </video>
      <button
        onClick={toggle}
        className="absolute bottom-3 left-3 inline-flex items-center gap-2 rounded-full border-[3px] border-white bg-tpeco-pink text-white px-4 py-1.5 font-display uppercase text-sm shadow-[0_4px_0_0_#0A0A0A] hover:translate-y-[1px] transition-transform"
        data-testid="sales-video-sound-toggle"
      >
        {muted ? <VolumeX className="w-4 h-4" strokeWidth={2.5} /> : <Volume2 className="w-4 h-4" strokeWidth={2.5} />}
        {muted ? "TAP FOR SOUND" : "MUTE"}
      </button>
    </div>
  );
}
